import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  createToastMessage,
  selectIsLoggedIn,
  selectPreviewMode,
} from "../store";
import i18n from "../i18n";

export default function usePreviewClickHandler(flagSelector) {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const previewMode = useSelector(selectPreviewMode);
  const canDo = useSelector(flagSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return {
    handleClickWhenLoggedIn: function handleClickWhenLoggedIn(action) {
      if (!previewMode && canDo) return action;

      if (isLoggedIn) {
        return () => {
          createToastMessage(dispatch, {
            type: "error",
            message: i18n.t("errors.unauthorized_error"),
          });
          return false;
        };
      }
      return () => navigate("/registration");
    },
  };
}
